
import { Component, InjectReactive, Vue, Watch } from 'nuxt-property-decorator';
import { PresentationMedia, FormFieldType, FileUploadDto, MediaEntry } from 'fourwaves-shared';
import { OutputFile, Alert } from 'fourwaves-shared/components';

@Component({
  components: {
    OutputFile,
    Alert,
  },
})
export default class PresentationSlidesSubview extends Vue {
  @InjectReactive() presentationMedia!: PresentationMedia;

  file: FileUploadDto | null = null;

  readonly FormFieldType = FormFieldType;

  get slidesUrl() {
    if (!this.presentationMedia.slides) return '';
    return `https://view.officeapps.live.com/op/embed.aspx?src=${this.$api.getFileUploadUrl(this.presentationMedia.slides.value)}`;
  }

  get isLessThan10Mb() {
    return !!this.file && this.file.size < 10 * 1024 * 1024;
  }

  @Watch('presentationMedia.slides', { immediate: true })
  async onSlidesChange(slides: MediaEntry<string> | null) {
    if (!slides) return;
    this.file = await this.$api.getFile(slides.value);
  }
}
